import { IJobTitleState, IStore } from 'store/types';
import { ILabor, ILaborLocation } from 'types';

// Shared empty arrays, so that with nothing loaded useSelector sees the same array each time instead of re-rendering on
// every store update.
const NO_POS_JOB_TITLES: IJobTitleState[] = [];
const NO_LABOR_RECORDS: ILabor[] = [];
const NO_LABOR_LOCATIONS: ILaborLocation[] = [];

export const selectPosJobTitles =
  () =>
  (state: IStore): IJobTitleState[] =>
    state.laborReview.posJobTitles || NO_POS_JOB_TITLES;

export const selectLaborRecords =
  () =>
  (state: IStore): ILabor[] =>
    state.laborReview.labor?.data || NO_LABOR_RECORDS;

// The locations the business day's labor was returned for, the primary one first.
export const selectLaborLocations =
  () =>
  (state: IStore): ILaborLocation[] =>
    state.laborReview.labor?.locations || NO_LABOR_LOCATIONS;
